import React from "react";
import { useNavigate } from "react-router-dom";
import hamburgerIcon from "../../Asset/Hamburger.svg";
import UsageLimitBanner from "../../pages/WebApp/components/UsageLimitBanner";
import WebAppPWAControls from "../WebAppPWAControls/WebAppPWAControls";
import NotificationBell from "../Notifications/NotificationBell";
import { useUsage } from "../../context/UsageContext";

// Notifications fetch is owned by NotificationsProvider — it fires once
// when the user logs in, then relies on SSE for updates. AppTopBar doesn't
// trigger any extra fetches across navigations between protected pages.
const AppTopBar = ({ onOpenSidebar }) => {
  const navigate = useNavigate();
  const { bannerState, bannerDismissed, dismissBanner } = useUsage();

  return (
    <div className="h-[88px] flex items-center gap-4 xl:px-10 lg:px-9 md:px-8 px-5 border-b border-[#0000001A]">
      <div className="flex items-center gap-3 shrink-0">
        <button
          type="button"
          onClick={onOpenSidebar}
          className="lg:hidden inline-flex items-center justify-center rounded-lg border border-[#0000001A] p-2 text-[#374151]"
          aria-label="Open sidebar"
        >
          <img src={hamburgerIcon} alt="" aria-hidden="true" className="size-5" />
        </button>
      </div>

      {bannerState && !bannerDismissed && (
        <UsageLimitBanner
          usedMinutes={bannerState.usedMinutes}
          totalMinutes={bannerState.totalMinutes}
          resetDay={bannerState.resetDay}
          onUpgrade={() => navigate("/settings")}
          onDismiss={dismissBanner}
          className="flex-1 min-w-0"
        />
      )}

      <div className="ml-auto flex items-center gap-2 sm:gap-3">
        <NotificationBell />
        <WebAppPWAControls />
      </div>
    </div>
  );
};

export default AppTopBar;
